var _a;
import { ENVS } from "@adsk/acs-sc-web-platform-api";
// Analytics Events
var CREATE_TEMPLATE_MODAL = "create_template_modal";
var CREATE_TEMPLATE_IN_SETTINGS_MODAL = "create_template_in_settings_modal";
export var AnalyticsEvents = {
  createTemplateModal: {
    closeModalFromHeader: "".concat(
      CREATE_TEMPLATE_MODAL,
      ".close_modal.click"
    ),
    nextButton: "".concat(CREATE_TEMPLATE_MODAL, ".next_button.click"),
    backButton: "".concat(CREATE_TEMPLATE_MODAL, ".back_button.click"),
    cancelButton: "".concat(CREATE_TEMPLATE_MODAL, ".cancel_button.click"),
    submitButton: "".concat(CREATE_TEMPLATE_MODAL, ".submit_button.click"),
    templateCreateTypeBlank: "".concat(
      CREATE_TEMPLATE_MODAL,
      ".template_create_type_blank.click"
    ),
    templateCreateTypeFromProject: "".concat(
      CREATE_TEMPLATE_MODAL,
      ".template_create_type_from_project.click"
    ),
    selectAccount: "".concat(CREATE_TEMPLATE_MODAL, ".select_account.click"),
    selectProject: "".concat(CREATE_TEMPLATE_MODAL, ".select_project.click"),
    submit: {
      duplicateNameError: "".concat(
        CREATE_TEMPLATE_MODAL,
        ".submit.error.duplicate_name"
      ),
      invalidNameError: "".concat(
        CREATE_TEMPLATE_MODAL,
        ".submit.error.invalid_name"
      ),
      nameTooLongError: "".concat(
        CREATE_TEMPLATE_MODAL,
        ".submit.error.name_too_long"
      ),
      otherError: "".concat(CREATE_TEMPLATE_MODAL, ".submit.error.other"),
      success: "".concat(CREATE_TEMPLATE_MODAL, ".submit.success"),
    },
  },
  createTemplateInSettingsModal: {
    closeModalFromHeader: "".concat(
      CREATE_TEMPLATE_IN_SETTINGS_MODAL,
      ".close_modal.click"
    ),
    cancelButton: "".concat(
      CREATE_TEMPLATE_IN_SETTINGS_MODAL,
      ".cancel_button.click"
    ),
    submitButton: "".concat(
      CREATE_TEMPLATE_IN_SETTINGS_MODAL,
      ".submit_button.click"
    ),
    submit: {
      duplicateNameError: "".concat(
        CREATE_TEMPLATE_IN_SETTINGS_MODAL,
        ".submit.error.duplicate_name"
      ),
      invalidNameError: "".concat(
        CREATE_TEMPLATE_IN_SETTINGS_MODAL,
        ".submit.error.invalid_name"
      ),
      nameTooLongError: "".concat(
        CREATE_TEMPLATE_IN_SETTINGS_MODAL,
        ".submit.error.name_too_long"
      ),
      otherError: "".concat(
        CREATE_TEMPLATE_IN_SETTINGS_MODAL,
        ".submit.error.other"
      ),
      success: "".concat(CREATE_TEMPLATE_IN_SETTINGS_MODAL, ".submit.success"),
    },
  },
};
export var ProjectPlatform;
(function (ProjectPlatform) {
  ProjectPlatform["Acc"] = "acc";
  ProjectPlatform["Bim"] = "bim360";
})(ProjectPlatform || (ProjectPlatform = {}));
export var AccountAccessLevel;
(function (AccountAccessLevel) {
  AccountAccessLevel["ProjectAdmin"] = "projectAdmin";
  AccountAccessLevel["AccountAdmin"] = "accountAdmin";
})(AccountAccessLevel || (AccountAccessLevel = {}));
export var FeatureFlag;
(function (FeatureFlag) {
  FeatureFlag["PL_PROJECT_ENTITLEMENTS_V2"] = "PL_PROJECT_ENTITLEMENTS_V2";
  FeatureFlag["PL_PROJECT_TEMPLATES_MAINTENANCE_MODE"] =
    "PL_PROJECT_TEMPLATES_MAINTENANCE_MODE";
})(FeatureFlag || (FeatureFlag = {}));
export var ProjectEntitlementsVersion;
(function (ProjectEntitlementsVersion) {
  ProjectEntitlementsVersion["V1"] = "v1";
  ProjectEntitlementsVersion["V2"] = "v2";
})(ProjectEntitlementsVersion || (ProjectEntitlementsVersion = {}));
export var LaunchDarklyIdByEnv =
  ((_a = {}),
  (_a[ENVS.QA] = "5cfe5a82648b9507525dcb0e"),
  (_a[ENVS.STAGING] = "5d12565bd7bc9707683c5682"),
  (_a[ENVS.PRODUCTION] = "5cfe5a817682e907558f568c"),
  _a);
export var MAX_PROJECTS_TO_DISPLAY = 200;
